import { Logger } from './logger';

export const wait = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

/** Waits for a function to complete and then delays for the same time as its execution time */
export const waitByResponseTime = async <T>(
  fn: () => Promise<T>,
  isLastIteration = false,
  verb = 'to delete',
  noun = 'next entry'
): Promise<T> => {
  const startTime = Date.now();

  const result = await fn();
  const operationTime = Date.now() - startTime;
  // Wait for at least the operation time (with minimum 100ms) to avoid API overload
  // Only delay if there are more entries to process after this one
  if (!isLastIteration) {
    const delayTime = Math.max(operationTime, 100);
    const isSlow = delayTime > 1500;
    Logger[isSlow ? 'info' : 'debug'](
      `Waiting for ${delayTime}ms ${verb} ${noun}`,
      !!isSlow
    );
    await wait(delayTime);
  }
  return result;
};
